import React from "react";
import { Instagram, ExternalLink } from "lucide-react";
import { BUSINESS, IMAGES } from "../lib/business";

// Static Instagram-style preview tiles using all unique client photos (no repetition)
const TILES = [
  { img: IMAGES.newTruck1, caption: "Nossa nova frota VW Guincho Refúgio" },
  { img: IMAGES.newTruck2, caption: "Guincho Refúgio — VW Express" },
  { img: IMAGES.mercedes, caption: "Mercedes 300SL clássico" },
  { img: IMAGES.audiQ5, caption: "Audi Q5 no Refúgio AutoCenter" },
  { img: IMAGES.porsche, caption: "Transporte de carro de luxo" },
  { img: IMAGES.newTruck3, caption: "Pronto para atender ao amanhecer" },
  { img: IMAGES.newTruck4, caption: "Nossa dupla de guinchos" },
  { img: IMAGES.heroTruckRain, caption: "Atendimento mesmo na chuva — 24h" },
  { img: IMAGES.cityRescue, caption: "Remoção em rodovia da região" },
  { img: IMAGES.autoCenter, caption: "Centro Automotivo próprio" },
];

export default function InstagramSection() {
  return (
    <section data-testid="instagram-section" className="bg-gradient-to-b from-[#0A0A0A] to-[#171717] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#E50914] px-3 py-1 mb-4">
              <Instagram className="w-4 h-4 text-white" />
              <span className="font-anton text-sm uppercase tracking-widest text-white">Instagram</span>
            </div>
            <h2 className="font-anton text-4xl md:text-5xl uppercase text-white leading-[0.95] mb-3">
              Acompanhe nossos
              <br />
              <span className="text-[#E50914]">atendimentos em tempo real</span>
            </h2>
            <p className="font-work text-zinc-300">
              Siga <strong className="text-white">{BUSINESS.instagramHandle}</strong> para ver resgates, dicas de mecânica e novidades.
            </p>
          </div>
          <a
            href={BUSINESS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-button"
            className="inline-flex items-center gap-2 bg-white hover:bg-zinc-100 text-black font-anton uppercase text-base md:text-lg tracking-wider px-6 py-3 transition-all hover:-translate-y-1 rounded-sm self-start"
          >
            <Instagram className="w-5 h-5" strokeWidth={2.5} />
            Ver Instagram Oficial
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2 md:gap-3">
          {TILES.map((t, i) => (
            <a
              key={i}
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="group relative aspect-square overflow-hidden border-2 border-zinc-800 hover:border-[#E50914] transition-colors block"
            >
              <img
                src={t.img}
                alt={t.caption}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/70 transition-colors flex items-center justify-center p-3">
                <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
